
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("ftUY6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProductsJswConfigurationDirectory", () => $970c0295584f412a$export$d611af4f2976883);
$parcel$export(module.exports, "default", () => $970c0295584f412a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $layKR = parcelRequire("layKR");

var $eIP9n = parcelRequire("eIP9n");

var $7vf5z = parcelRequire("7vf5z");

var $3pQEp = parcelRequire("3pQEp");

var $6M8Uw = parcelRequire("6M8Uw");

var $aUMbW = parcelRequire("aUMbW");
const $970c0295584f412a$var$APP_NAME = 'products-jsw-configuration';
const $970c0295584f412a$export$d611af4f2976883 = ()=>{
    const { data: data, loading: loading } = (0, $layKR.useProductsJswConfigurationResource)();
    if (loading || data == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eIP9n.ProductsJswConfiguration), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: $970c0295584f412a$var$APP_NAME,
        metric: (0, $aUMbW.JSWConfigurationPageLoad)
    }));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$970c0295584f412a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3pQEp.default), {
        id: "spa-app-bootstrap.directories.products-jsw-configuration"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($970c0295584f412a$export$d611af4f2976883, null)));

});
parcelRegister("layKR", function(module, exports) {

$parcel$export(module.exports, "useProductsJswConfigurationResource", () => $9df488ac4af0b799$export$549d5521bb6309f2);
$parcel$export(module.exports, "useFeatures", () => $9df488ac4af0b799$export$4a39035bacc4ed76);

var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8vc2n = parcelRequire("8vc2n");

var $lB25E = parcelRequire("lB25E");
const $9df488ac4af0b799$export$549d5521bb6309f2 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data: data, update: update, loading: loading } = (0, $lB25E.useResource)((0, $8vc2n.productsJswConfigurationResource));
    return {
        data: data,
        update: update,
        loading: loading
    };
};
const $9df488ac4af0b799$export$4a39035bacc4ed76 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: data, update: update } = $9df488ac4af0b799$export$549d5521bb6309f2();
    const updateFeature = (0, $eUqFw.useCallback)(async (key, value)=>{
        const url = `/rest/greenhopper/latest/jswfeature?features=${key}`;
        try {
            await (0, $lRmyA.performPostRequest)(url, {
                body: JSON.stringify({
                    featureKey: key,
                    value: value
                })
            });
            // only fire analytic when the update was done successfully
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(key)}JswConfiguration updated`, {
                value: value
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'productsJswConfig',
                    packageName: 'jiraProductsJswConfigurationMain'
                }
            });
        }
        update((currentData)=>({
                ...currentData,
                [key]: value
            }));
    }, [
        update,
        createAnalyticsEvent
    ]);
    return {
        data: data,
        updateFeature: updateFeature
    };
};

});

parcelRegister("eIP9n", function(module, exports) {

$parcel$export(module.exports, "ProductsJswConfiguration", () => $6c6d83804f5ef4c0$export$159bfd96fd0ce27d);

var $eUqFw = parcelRequire("eUqFw");

var $bEZRh = parcelRequire("bEZRh");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $g9zGt = parcelRequire("g9zGt");

var $gd0Sp = parcelRequire("gd0Sp");

var $25YUH = parcelRequire("25YUH");

var $aPOrw = parcelRequire("aPOrw");
const $6c6d83804f5ef4c0$export$159bfd96fd0ce27d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!tenantContext.isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.GenericPermissionErrorPageAsync), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "productsJswConfiguration",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $25YUH.default).jswConfigHeaderSpork)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9zGt.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aPOrw.JswConfigurationContent), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("g9zGt", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $ac12849d4f958630$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $ac12849d4f958630$export$6d1402fb58384e4f);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $ac12849d4f958630$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $ac12849d4f958630$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: "space.500"
    }, children);
const $ac12849d4f958630$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: hideMargin ? $ac12849d4f958630$var$pageLayoutWithoutMarginStyles : $ac12849d4f958630$var$pageLayoutWithMarginStyles
    }, children);
const $ac12849d4f958630$var$scrollablePageStyles = (0, $1ZAYh.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $ac12849d4f958630$var$pageLayoutWithoutMarginStyles = (0, $1ZAYh.xcss)({
    margin: 'space.0'
});
const $ac12849d4f958630$var$pageLayoutWithMarginStyles = (0, $1ZAYh.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});

});

parcelRegister("25YUH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4651616093772c8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f4651616093772c8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jswConfigHeaderSpork: {
        "id": "products-jsw-configuration-main.jsw-config-header.jsw-config-header-spork",
        "defaultMessage": "Software project configuration"
    }
});

});

parcelRegister("aPOrw", function(module, exports) {

$parcel$export(module.exports, "JswConfigurationContent", () => $b98b9f918422c083$export$49e4aaf199874781);

var $eUqFw = parcelRequire("eUqFw");

var $dfHGq = parcelRequire("dfHGq");

var $agBvi = parcelRequire("agBvi");
const $b98b9f918422c083$export$49e4aaf199874781 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agBvi.JswConfigHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dfHGq.FeaturesSection), null));

});
parcelRegister("dfHGq", function(module, exports) {

$parcel$export(module.exports, "FeaturesSection", () => $bc17bfe4fc61dfe8$export$b6125dcde81daafc);

var $eUqFw = parcelRequire("eUqFw");

var $2RSDl = parcelRequire("2RSDl");

var $layKR = parcelRequire("layKR");

var $1crrz = parcelRequire("1crrz");

var $3HQiG = parcelRequire("3HQiG");
const $bc17bfe4fc61dfe8$var$PARALLEL_SPRINTS_FEATURE_KEY = 'PARALLEL_SPRINTS';
const $bc17bfe4fc61dfe8$var$LOCAL_DEVICE_CACHE_FEATURE_KEY = 'LOCAL_DEVICE_CACHE';
const $bc17bfe4fc61dfe8$export$b6125dcde81daafc = ()=>{
    const { data: data, updateFeature: updateFeature } = (0, $layKR.useFeatures)();
    const isParallelSprintsFeatureVisible = $bc17bfe4fc61dfe8$var$PARALLEL_SPRINTS_FEATURE_KEY in data;
    const isLocalDeviceCacheFeatureVisible = $bc17bfe4fc61dfe8$var$LOCAL_DEVICE_CACHE_FEATURE_KEY in data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isParallelSprintsFeatureVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3HQiG.ParallelSprintFeatureSection), {
        featureKey: $bc17bfe4fc61dfe8$var$PARALLEL_SPRINTS_FEATURE_KEY,
        value: data[$bc17bfe4fc61dfe8$var$PARALLEL_SPRINTS_FEATURE_KEY],
        onUpdateFeature: updateFeature
    }), isLocalDeviceCacheFeatureVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.HorizontalSeperator), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1crrz.LocalDeviceCacheSection), {
        featureKey: $bc17bfe4fc61dfe8$var$LOCAL_DEVICE_CACHE_FEATURE_KEY,
        value: data[$bc17bfe4fc61dfe8$var$LOCAL_DEVICE_CACHE_FEATURE_KEY],
        onUpdateFeature: updateFeature
    })));
};

});
parcelRegister("2RSDl", function(module, exports) {

$parcel$export(module.exports, "FeatureContainer", () => $568d17ec1967b694$export$71e44c7c40f9a5c2);
$parcel$export(module.exports, "FeatureTextContainer", () => $568d17ec1967b694$export$cbb8144ab7dd951f);
$parcel$export(module.exports, "FeatureSubtitle", () => $568d17ec1967b694$export$89f90dc1f64f0e8e);
$parcel$export(module.exports, "FeatureToggleText", () => $568d17ec1967b694$export$c7d1baf7582972dc);
$parcel$export(module.exports, "FeatureToggle", () => $568d17ec1967b694$export$8e25d4633f989d7a);
$parcel$export(module.exports, "HorizontalSeperator", () => $568d17ec1967b694$export$a3ba86a0af5fa1db);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $568d17ec1967b694$export$71e44c7c40f9a5c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _4cvrh9n0 _yv0em91j _2z05im57 _1lmc1vze _p12f8stt _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $568d17ec1967b694$export$cbb8144ab7dd951f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nd5l1fja _n3tdpxbi",
            __cmplp.className
        ])
    });
});
const $568d17ec1967b694$export$89f90dc1f64f0e8e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $568d17ec1967b694$export$c7d1baf7582972dc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nd5lxng3",
            __cmplp.isDisabled && "_tzy41e4z",
            __cmplp.className
        ])
    });
});
const $568d17ec1967b694$export$8e25d4633f989d7a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_10fph9n0 _1wpz1h6o _nd5l1728 _1y0gmbak",
            __cmplp.className
        ])
    });
});
const $568d17ec1967b694$export$6dc9c7a2fd68ee6d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4zu5n",
            __cmplp.className
        ])
    });
});
const $568d17ec1967b694$export$a3ba86a0af5fa1db = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3it94y _18s850w7 _bfhkb5v6",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1crrz", function(module, exports) {

$parcel$export(module.exports, "LocalDeviceCacheSection", () => $8355da10e68a2e12$export$b5b59343928c7126);

var $eUqFw = parcelRequire("eUqFw");

var $6ROLN = parcelRequire("6ROLN");

var $hI5oG = parcelRequire("hI5oG");

var $e270j = parcelRequire("e270j");

var $9ENT0 = parcelRequire("9ENT0");

var $k5Ock = parcelRequire("k5Ock");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2RSDl = parcelRequire("2RSDl");

var $hAtO8 = parcelRequire("hAtO8");
// Article ID for related help article
const $8355da10e68a2e12$var$ARTICLE_ID = '6q0itr2i2wrpSFNhHIx42g';
const $8355da10e68a2e12$var$ANALYTICS_ID = `products-jsw.features.local-device-cache.help-article-${$8355da10e68a2e12$var$ARTICLE_ID}`;
const $8355da10e68a2e12$export$b5b59343928c7126 = (props)=>{
    const { featureKey: featureKey, value: value, onUpdateFeature: onUpdateFeature } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cmpBoardCache = (0, $9ENT0.createIndexedDBStorageProvider)('cmp-board');
    const cmpBacklogCache = (0, $9ENT0.createIndexedDBStorageProvider)('cmp-backlog');
    const handleOnChange = ()=>{
        // Clear everything if the toggle was on
        // Site users will have data cleared next board or backlog visit
        if (value) {
            cmpBoardCache.clearAll();
            cmpBacklogCache.clearAll();
        }
        onUpdateFeature(featureKey, !value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureContainer), {
        key: featureKey,
        "data-testid": "products-jsw-configuration-main.ui.features-section.local-device-cache"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h500",
        as: "h2"
    }, formatMessage((0, $hAtO8.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureToggleText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureSubtitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: "toggle-feature-local-device-cache"
    }, formatMessage((0, $hAtO8.default).description, {
        button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k5Ock.InProductHelpButton), {
                articleId: $8355da10e68a2e12$var$ARTICLE_ID,
                articleAnalyticsId: $8355da10e68a2e12$var$ANALYTICS_ID,
                appearance: "link"
            }, chunks)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureToggle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        id: "toggle-feature-local-device-cache",
        name: featureKey,
        label: value ? formatMessage((0, $hAtO8.default).toggleLabelOptingIn) : formatMessage((0, $hAtO8.default).toggleLabelOptingOut),
        isChecked: value,
        onChange: handleOnChange
    })));
};

});
parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});



parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});

parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform-visual-refresh-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';




parcelRegister("9ENT0", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $6d438df2aac0e8d6$export$6ba36c4f5fb8919d);

var $jqvCZ = parcelRequire("jqvCZ");

var $gAbZm = parcelRequire("gAbZm");
const $6d438df2aac0e8d6$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $gAbZm.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $gAbZm.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("gAbZm", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $36fa2b3f05c0cdab$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $36fa2b3f05c0cdab$export$8432fe49db7d8865);

var $k1THV = parcelRequire("k1THV");
const $36fa2b3f05c0cdab$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $36fa2b3f05c0cdab$var$createCustomStore = ()=>(0, $k1THV.createStore)('keyval-store', 'keyval');
let $36fa2b3f05c0cdab$var$customStore;
const $36fa2b3f05c0cdab$var$getStore = ()=>{
    let store = $36fa2b3f05c0cdab$var$customStore;
    if (!store) {
        $36fa2b3f05c0cdab$var$customStore = $36fa2b3f05c0cdab$var$createCustomStore();
        store = $36fa2b3f05c0cdab$var$customStore;
    }
    return store;
};
const $36fa2b3f05c0cdab$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $36fa2b3f05c0cdab$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$36fa2b3f05c0cdab$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $k1THV.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $36fa2b3f05c0cdab$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $k1THV.get)(prefix(key), $36fa2b3f05c0cdab$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $k1THV.del)(prefixedKey, $36fa2b3f05c0cdab$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $k1THV.get)(KEYS_STORE_PREFIX, $36fa2b3f05c0cdab$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $k1THV.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $k1THV.update)(prefixedKey, value);
            else (0, $k1THV.set)(prefixedKey, value, $36fa2b3f05c0cdab$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $36fa2b3f05c0cdab$var$customStore = $36fa2b3f05c0cdab$var$createCustomStore();
        }
    };
};
const $36fa2b3f05c0cdab$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("k1THV", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e94f1cffaec1fb5e$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e94f1cffaec1fb5e$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e94f1cffaec1fb5e$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e94f1cffaec1fb5e$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e94f1cffaec1fb5e$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e94f1cffaec1fb5e$export$c8aa84257229cac8);
function $e94f1cffaec1fb5e$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e94f1cffaec1fb5e$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e94f1cffaec1fb5e$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e94f1cffaec1fb5e$var$defaultGetStoreFunc;
function $e94f1cffaec1fb5e$var$defaultGetStore() {
    if (!$e94f1cffaec1fb5e$var$defaultGetStoreFunc) $e94f1cffaec1fb5e$var$defaultGetStoreFunc = $e94f1cffaec1fb5e$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e94f1cffaec1fb5e$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$3988ae62b71be9a3(key, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e94f1cffaec1fb5e$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$adaa4cf7ef1b65be(key, value, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$daa0a5170277c7a8(entries, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$5df405cccea42673(keys, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e94f1cffaec1fb5e$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$722fbec263ad908a(key, updater, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$1d2f21e549771e67(key, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$c8aa84257229cac8(keys, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$42ffd38884aecdac(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
function $e94f1cffaec1fb5e$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$ed97f33186d4b816(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$68c286be0e7e55b7(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$3e9f948b41964866(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAllKeys()),
            $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});



parcelRegister("k5Ock", function(module, exports) {

$parcel$export(module.exports, "useInProductHelp", () => $46b302622ca7fadb$export$804f42d1448e5b9);
$parcel$export(module.exports, "InProductHelpButton", () => $46b302622ca7fadb$export$b14685a9b52779e1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $2eG9N = parcelRequire("2eG9N");

var $3QLcd = parcelRequire("3QLcd");

var $jMP2a = parcelRequire("jMP2a");
const $46b302622ca7fadb$export$804f42d1448e5b9 = ({ articleId: articleId, articleAnalyticsId: articleAnalyticsId, analyticsAttributes: analyticsAttributes = {} })=>{
    const onOpenInProductHelpArticle = (0, $3QLcd.useHelpPanelLink)();
    const onClick = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        if (!articleId || !articleAnalyticsId) return;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, articleAnalyticsId, analyticsAttributes);
        onOpenInProductHelpArticle?.(articleId);
    }, [
        onOpenInProductHelpArticle,
        articleAnalyticsId,
        articleId,
        analyticsAttributes
    ]);
    return {
        onClick: onClick
    };
};
const $46b302622ca7fadb$export$b14685a9b52779e1 = ({ children: children, articleId: articleId, articleAnalyticsId: articleAnalyticsId, tooltip: tooltip, appearance: appearance, analyticsAttributes: analyticsAttributes = {}, spacing: spacing = 'none', fontWeight: fontWeight })=>{
    const onOpenInProductHelpArticle = (0, $3QLcd.useHelpPanelLink)();
    const onClickHandler = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, articleAnalyticsId, analyticsAttributes);
        onOpenInProductHelpArticle?.(articleId);
    }, [
        onOpenInProductHelpArticle,
        articleAnalyticsId,
        articleId,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, onOpenInProductHelpArticle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46b302622ca7fadb$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: tooltip != null ? tooltip : children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46b302622ca7fadb$var$StyledButton, {
        onClick: onClickHandler,
        appearance: appearance != null ? appearance : 'subtle',
        spacing: spacing,
        fontWeight: fontWeight
    }, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $46b302622ca7fadb$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_161n68f": (0, $9t7rW.default)(__cmplp.fontWeight)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.fontWeight !== undefined && "_k48ppyab",
            __cmplp.className
        ])
    });
});
const $46b302622ca7fadb$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});


parcelRegister("hAtO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $619a88d15e83a29f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $619a88d15e83a29f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "products-jsw-configuration-main.features-section.local-device-cache.title",
        "defaultMessage": "Store Jira data on your own device"
    },
    description: {
        "id": "products-jsw-configuration-main.features-section.local-device-cache.description",
        "defaultMessage": "Store frequently accessed data on your device to help your Jira board and backlog load faster. This setting applies to all users on your Jira site. When the setting is turned off, any stored data will be deleted. <button>How will my data be stored?</button>"
    },
    toggleLabelOptingIn: {
        "id": "products-jsw-configuration-main.features-section.local-device-cache.toggle-label-opting-in",
        "defaultMessage": "Toggle on local device cache"
    },
    toggleLabelOptingOut: {
        "id": "products-jsw-configuration-main.features-section.local-device-cache.toggle-label-opting-out",
        "defaultMessage": "Toggle off local device cache"
    }
});

});


parcelRegister("3HQiG", function(module, exports) {

$parcel$export(module.exports, "ParallelSprintFeatureSection", () => $e4381e084394a75a$export$e6f5a7ab5d0f6592);

var $eUqFw = parcelRequire("eUqFw");

var $6ROLN = parcelRequire("6ROLN");

var $hI5oG = parcelRequire("hI5oG");

var $e270j = parcelRequire("e270j");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2RSDl = parcelRequire("2RSDl");

var $fBFHg = parcelRequire("fBFHg");
const $e4381e084394a75a$export$e6f5a7ab5d0f6592 = (props)=>{
    const { featureKey: featureKey, value: value, onUpdateFeature: onUpdateFeature } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureContainer), {
        key: featureKey,
        "data-testid": "products-jsw-configuration-main.ui.features-section.parallel-sprints.parallel-sprint-feature-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $fBFHg.default).parallelSprintsTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureToggleText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureSubtitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: "toggle-feature-parallel-sprints"
    }, formatMessage((0, $fBFHg.default).parallelSprintsDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSDl.FeatureToggle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        id: "toggle-feature-parallel-sprints",
        name: featureKey,
        label: value ? formatMessage((0, $fBFHg.default).parallelSprintsToggleLabelOptingIn) : formatMessage((0, $fBFHg.default).parallelSprintsToggleLabelOptingOut),
        isChecked: value,
        onChange: ()=>{
            onUpdateFeature(featureKey, !value);
        }
    })));
};

});
parcelRegister("fBFHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d46bbe712d0c353$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0d46bbe712d0c353$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    parallelSprintsTitle: {
        "id": "products-jsw-configuration-main.features-section.parallel-sprints.parallel-sprints-title",
        "defaultMessage": "Parallel sprints for company-managed projects"
    },
    parallelSprintsDescription: {
        "id": "products-jsw-configuration-main.features-section.parallel-sprints.parallel-sprints-description",
        "defaultMessage": "Allow multiple sprints to run at the same time. This feature doesn't apply to team-managed projects."
    },
    parallelSprintsToggleLabelOptingIn: {
        "id": "products-jsw-configuration-main.features-section.parallel-sprints.parallel-sprints-toggle-label-opting-in",
        "defaultMessage": "Toggle on parallel sprints"
    },
    parallelSprintsToggleLabelOptingOut: {
        "id": "products-jsw-configuration-main.features-section.parallel-sprints.parallel-sprints-toggle-label-opting-out",
        "defaultMessage": "Toggle off parallel sprints"
    }
});

});



parcelRegister("agBvi", function(module, exports) {

$parcel$export(module.exports, "JswConfigHeader", () => $182a447d63c1e65c$export$92f6e65ac32dd911);

var $eUqFw = parcelRequire("eUqFw");

var $3a8wJ = parcelRequire("3a8wJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $25YUH = parcelRequire("25YUH");
const $182a447d63c1e65c$export$92f6e65ac32dd911 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), null, formatMessage((0, $25YUH.default).jswConfigHeaderSpork)));
};

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});






parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("3pQEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc5d844a0c4163b4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $78d1w = parcelRequire("78d1w");
const $dc5d844a0c4163b4$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "spa-apps.error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78d1w.default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
        const extraEventData = {
            transitionsCount: transitionsCount,
            lastTransition: lastTransition,
            navigationStart: navigationStart
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
            id: id,
            extraEventData: extraEventData
        }, children);
    }));
const $dc5d844a0c4163b4$var$SpaErrorBoundary = $dc5d844a0c4163b4$var$ErrorBoundaryWithExtraEventData;
var $dc5d844a0c4163b4$export$2e2bcd8739ae039 = $dc5d844a0c4163b4$var$SpaErrorBoundary;

});

parcelRegister("aUMbW", function(module, exports) {

$parcel$export(module.exports, "JSWConfigurationPageLoad", () => $3b61a9eba4797e9d$export$6482cd4a2a1a86b);

var $lNfG4 = parcelRequire("lNfG4");
const $3b61a9eba4797e9d$export$6482cd4a2a1a86b = (0, $lNfG4.metrics).pageLoad({
    key: 'admin.jsw-configuration'
});

});



//# sourceMappingURL=async-products-jsw-configuration.9c06647f.js.map
